import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {
  Row,
  Col,
  Icon,
  Grid,
  Table,
  Panel,
  PanelHeader,
  PanelBody,
  PanelContainer,
  PanelTabContainer,
  Radio,
  Checkbox,
  FormGroup,
  InputGroup,
  ControlLabel,
  Button,
  Form,
  FormControl,
  Well,
} from '@sketchpixy/rubix';
import _ from 'lodash';

import {
  getClinicianList,
  getPatientListForMapping,
  getPatientClinicianMapping,
  mapClinicianToPatients,
  getServiceRegion,
} from '../../../api/api';
import RoleType from '../../RoleGroup/Roles/RoleType';
import {checkRole} from '../../../util/RoleChecker';
import {routeUrl} from '../../routeUrl';

const CHECKED_BUTTON_ICON = 'icon-fontello-check-3';
const UNCHECKED_BUTTON_ICON = 'icon-fontello-check-empty-1';
const REGION_ALL = '';

export default class Clinician extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clinicians: [],
      roleRegion: REGION_ALL,
      serviceRegions: [],
      datatables: null,
      search: {
          country: REGION_ALL,
          query: '',
          gender: '',
          typeId: null
      }
    };
  }

  componentDidMount() {
    let self = this;

    Messenger.options = {
      theme: 'flat',
    };

    const requiredRoles = [
      RoleType.CLINICIAN_PATIENT_MAPPING,
      RoleType.CLINICIAN_PATIENT_MAPPING_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = null;

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    this.setState({
      roleRegion,
      search: {country: (roleRegion === 'ALL' ? '' : roleRegion)}
    });

    getServiceRegion((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          serviceRegions: result.list,
        });
      }
    });

    let datatableDom = $(ReactDOM.findDOMNode(this.refs.cliniciansListTable));
    if ($.fn.DataTable.isDataTable(datatableDom ) ) {
       return;
    }

    let datatables = datatableDom.addClass('nowrap')
      .DataTable({
        language: { infoFiltered: "" },
        processing: true,
        serverSide: true,
        responsive: true,
        searchDelay: 2000,
        searching: false,
        ajax : function (data, callback, settings) {
           let search = self.state.search;
           let param = _.merge({}, data, search)
           getClinicianList(param, (err, res) => {
             callback(res.clinicians);
           });
        },
        columns: [
            {
              name: 'clinicianDto.clinicianFirstName',
              data: 'clinicianDto.clinicianFirstName',
              defaultContent : "",
              render: function ( data, type, row ) {
                  return data.length > 20 ? data.substr( 0, 20 ) +'…' : data;
               }
            },
            {
              name: 'clinicianDto.clinicianLastName',
              data: 'clinicianDto.clinicianLastName',
              defaultContent : "",
                render: function ( data, type, row ) {
                    return data.length > 20 ? data.substr( 0, 20 ) +'…' : data;
                }
            },
            {
              name: 'clinicianDto.clinicianTypeDto.clinicianTypeName',
              data: 'clinicianDto.clinicianTypeDto.clinicianTypeName',
              defaultContent : ""
            },
            {
              name: 'userDto.userEmail',
              data: 'userDto.userEmail',
              defaultContent : ""
            },
            {
                name: 'clinicianDto.clinicianGender',
                data: 'clinicianDto.clinicianGender',
                defaultContent : "",
                render: function ( data, type, row ) {
                    let str = data.toLowerCase()
                    return str.charAt(0).toUpperCase() + str.slice(1);
                }
            },
            {
                name: 'clinicianDto.countryDto.countryAlpha3Code',
                data: 'clinicianDto.countryDto.countryAlpha3Code',
                defaultContent : ""
            },
            {
                name: 'clinicianDto.createdTime',
                data: 'clinicianDto.createdTime',
                defaultContent : "",
                render: function (d, type, row) {
                    return moment(d).format('MMMM Do YYYY, h:mm:ss a')
                }
              },
            {
              name: 'clinicianDto.updatedTime',
              data: 'clinicianDto.updatedTime',
              defaultContent : "",
              render: function (d, type, row) {
                  return moment(d).format('MMMM Do YYYY, h:mm:ss a')
              }
            },
            {
              name: 'actions',
              data: 'clinicianId',
              orderable: false,
              defaultContent : "",
              render: function (clinicianId, type, row) {
                let buttons = '';

                buttons +="<Button class='btn btn-info'  data-id='"+clinicianId+"' data-action='MAPPING'>Patient Mapping</Button>"; //수정

                return buttons;
              }
            },
        ],
        rowId: 'rapaelClientId',
        select: true
    });

    datatableDom.find('tbody').on('click', 'button',  function (event) {
      let clinicianId = $(event.target).data("id");
      let action = $(event.target).data("action");
      switch(action)
      {
        case 'MAPPING':
          self.props.editPatientMapping(clinicianId);
          break;
      }
    });

    this.setState({
       datatables: datatables
    },() => {
       self.doSearch();
    });
  }


  doSearch = () => {
      this.state.datatables.ajax.reload();
  }

  clinicianCountryChangeHandler = (event) => {
    let country = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
       search: {...this.state.search, country: country},
    });
  };

  queryChangeHandler = (event) => {
    let query = event.target.value;
    this.setState({
      search: {...this.state.search, query: query},
    });
  };

  genderChangeHandler = (event) => {
    let gender = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
      search: {...this.state.search, gender: gender},
    });
  };

  onChangeMappingType = (event) => {
        let mappingType = event.target.value;
        if(mappingType === 'pc')
        {
            this.props.router.push('/rapael-home/cp-mapping');
        }
  };

  render() {
    return (
                          <PanelContainer controls={false}>
                            <Panel>
                              <PanelHeader>
                                <Grid>
                                  <Row>
                                    <Col xs={12}>
                                      <h3>Clinician list</h3>
                                      <Well>
                                        <Form inline>
                                          <FormGroup controlId="clinicianCountrySelect">
                                            <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Country</ControlLabel>
                                            <FormControl
                                                onChange={this.clinicianCountryChangeHandler}
                                                componentClass="select"
                                                style={{width: '120px'}}
                                            >
                                              <option value=''>ALL</option>
                                              {
                                                this.state.serviceRegions.map(serviceRegion => (
                                                    <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                                      {serviceRegion.countryAlpha3Code}
                                                    </option>
                                                ))
                                              }
                                            </FormControl>
                                          </FormGroup>
                                          <FormGroup>
                                              <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Gender</ControlLabel>
                                              <FormControl
                                                  onChange={this.genderChangeHandler}
                                                  componentClass="select"
                                                  style={{width: '120px'}}
                                              >
                                                <option value=''>ALL</option>
                                                <option value='MALE'>Male</option>
                                                <option value='FEMALE'>Female</option>
                                                <option value='OTHER'>Other</option>
                                              </FormControl>
                                            </FormGroup>
                                            <FormGroup>
                                              <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Search Word</ControlLabel>
                                              <FormControl type='text' placeholder='Search Word' onChange={this.queryChangeHandler} style={{width: '120px'}}/>
                                            </FormGroup>
                                            <FormGroup className="pull-right">
                                              <InputGroup.Button>
                                              <Button  onClick={this.doSearch}>Search</Button>
                                              </InputGroup.Button>
                                            </FormGroup>
                                        </Form>
                                      </Well>
                                    </Col>
                                  </Row>
                                </Grid>
                              </PanelHeader>
                              <PanelBody style={{padding: 0}}>
                                <Table ref="cliniciansListTable" className='display' cellSpacing='0' width='100%'>
                                <thead>
                                  <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Clinician Type</th>
                                    <th>Email</th>
                                    <th>Gender</th>
                                    <th>Country</th>
                                    <th>Created Date</th>
                                    <th>Modified Date</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                              </Table>
                              </PanelBody>
                            </Panel>
                          </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/cp-mapping/components/Clinician.js